module.exports = __webpack_public_path__ + "img/thumbnail-parking.291bcf6d.jpg";